module.exports = __webpack_public_path__ + "static/media/icon-nav-heart.4c0bbab3.svg";